// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/spotlight.css
// module id = 6321
// module chunks = 0